module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 024.52f8a26c.jpg";